import { cloudName } from './routes';

const TLS_SECURE_DELIVERY = 'res-s.cloudinary.com';

const EASY_CUSTOMIZATION_CONFIG = {
  logErrors: true,
  analytics: true,
  container: '#easy-customization-gallery',
  cloudName: cloudName,
  mediaAssets: [
    {tag: 'shoes_product_gallery_demo', mediaType: 'image'},
    {tag: 'shoes_product_gallery_demo', mediaType: 'video'},
    {tag: 'shoes_product_gallery_demo_spinset', mediaType: 'spin'},
  ],
  displayProps: {
    mode: 'classic',
    columns: 1,
    spacing: 15,
    topOffset: 100
  },
  aspectRatio: '3:4',
  transformation: {
    crop: 'fill',
  },
  bgColor: 'transparent',
  carouselLocation: 'left',
  carouselOffset: 10,
  navigation: 'always',
  thumbnailProps: {
    mediaSymbolSize: 42,
    spacing: 20,
    width: 90,
    height: 90,
    navigationFloat: true,
    navigationShape: 'square',
    navigationSize: 40,
    navigationColor: '#ffffff',
    selectedStyle: 'border',
    selectedBorderPosition: 'bottom',
    selectedBorderWidth: 4
  },
  navigationButtonProps: {
    shape: 'rectangle',
    iconColor: '#ffffff',
    color: '#000',
    size: 52,
    navigationPosition: 'offset',
    navigationOffset: 12,
  },
  themeProps: {
    primary: '#000000',
    active: '#777777'
  },
  viewportBreakpoints: [],
  secureDistribution: TLS_SECURE_DELIVERY,
  secure: true
};

const DYNAMIC_URL_CONFIG = {
  logErrors: true,
  analytics: true,
  container: '#dynamic-url-gallery',
  cloudName: cloudName,
  mediaAssets: [
    { tag: 'tshirt_product_gallery_demo', mediaType: 'image'}
  ],
  bgColor: 'transparent',
  carouselLocation: 'left',
  carouselOffset: 10,
  navigation: 'always',
  aspectRatio: 'square',
  thumbnailProps: {
    spacing: 18,
    width: 90,
    height: 120,
    navigationStyle: 'scroll',
    navigationShape: 'none',
    selectedStyle: 'all',
    selectedGradientEnd: '#ffffff',
    selectedGradientDirection: 'vertical',
    selectedBorderPosition: 'bottom',
    selectedBorderColor: '#777777',
    selectedBorderWidth: 4,
    transformation: {
      transformation: [
        {},
        {effect: 'replace_color:7CA9CB:10:7CA9CB'},
        {},
      ]
    }
  },
  viewportBreakpoints: [],
  navigationButtonProps: {
    shape: 'rectangle',
    iconColor: '#ffffff',
    color: '#000',
    size: 52,
    navigationPosition: 'offset',
    navigationOffset: 12,
  },
  zoom: true,
  carouselStyle: 'thumbnails',
  zoomProps: {
    type: 'inline',
    trigger: 'hover',
    level: 1.5,
    showLens: true,
    lensOpacity: 0.2,
    lensBorderWidth: 1,
    lensShadow: true
  },
  transformation: {
    crop: 'fill',
    transformation: [
      {
        effect: 'replace_color:7CA9CB:10:7CA9CB'
      },
      {
        gravity: 'north_west',
        x: 0,
        y: 40,
        color: '#ffffff',
        background: 'black',
        border: '5px_solid_black',
        overlay: {
          font_family: 'Poppins',
          font_weight: 'light',
          font_size: 40,
          text: encodeURIComponent(' -40% ')
        }
      },
      {
        gravity: 'south_east',
        x: 30,
        y: 30,
        overlay: {
          public_id: 'Product%20gallery%20demo/New%20Demo%20Pages/Tshirt/cld-logo'
        }
      },
      { dpr: 'auto' }
    ]
  },
  secureDistribution: TLS_SECURE_DELIVERY,
  secure: true
};

const EVENTS_AND_ANALYTICS_CONFIG = {
  analytics: true,
  container: '#events-and-analytics-gallery',
  cloudName: cloudName,
  mediaAssets: [
    { tag: 'bag_product_gallery_demo', mediaType: 'image', transformation: { crop: 'fill' } }
  ],
  bgColor: 'transparent',
  carouselLocation: 'left',
  carouselOffset: 10,
  navigation: 'always',
  aspectRatio: 'square',
  themeProps: {
    active: '#000000'
  },
  navigationButtonProps: {
    shape: 'rectangle',
    color: '#000',
    iconColor: '#fff',
    size: 52,
  },
  thumbnailProps: {
    spacing: 18,
    width: 83,
    height: 80,
    navigationFloat: true,
    mediaSymbolBgShape: 'square',
    navigationShape: 'none',
    selectedStyle: 'all',
    selectedGradientEnd: '#ffffff',
    selectedGradientDirection: 'vertical',
    selectedBorderPosition: 'bottom'
  },
  viewportBreakpoints: [],
  zoom: true,
  zoomProps: {
    trigger: 'click',
    level: 2
  },
  secureDistribution: TLS_SECURE_DELIVERY,
  secure: true
};

const DEMO_GALLERY_CONFIG = {
  logErrors: true,
  analytics: true,
  container: '#my-gallery',
  cloudName: cloudName,
  displayProps: {
    mode: 'classic',
    columns: 1
  },
  mediaAssets: [
    {tag: 'shoes_product_gallery_demo', mediaType: 'image'},
    {tag: 'shoes_product_gallery_demo', mediaType: 'video'},
    {tag: 'shoes_product_gallery_demo_spinset', mediaType: 'spin'},
  ],
  viewportBreakpoints: [],
};

const EVENTS = [
  'mouseleave',
  'mouseenter',
  'nextasset',
  'init',
  'videoend',
  'videostart',
  '360click',
  'zoomout',
  'zoomin',
  'thumbnailclick',
  'indicatorclick',
  'thumbnext',
  'thumbprev',
  'thumbclick',
  'viewerprev',
  'viewernext',
  'videopause',
  'videoprogress',
];

const UPLOAD_WIDGET_CONFIG = {
  cloudName: cloudName,
  styles: {
    palette: {
      inactiveTabIcon: '#000000',
      tabIcon: '#375ce4',
      link: '#375ce4',
      windowBorder: '#000000',
      sourceBg: '#FFFFFF',
      menuIcons: '#000000',
    }
  },
  uploadPreset: 'blog_upload',
  folder: 'pg-public-demo-app',
  source: 'uw',
  clientAllowedFormats: ['png','jpg', 'jpeg'],
  showAdvancedOptions: true,
  viewportBreakpoints: []
};

export {
  EASY_CUSTOMIZATION_CONFIG,
  DYNAMIC_URL_CONFIG,
  EVENTS_AND_ANALYTICS_CONFIG,
  DEMO_GALLERY_CONFIG,
  EVENTS,
  UPLOAD_WIDGET_CONFIG,
};
